import ControlFactory from '@/Factories/ControlFactory';
import EmbeddedListViewFactoryT from '@/Factories/ControlFactories/EmbeddedListViewFactory';
import EmptyElementFactoryT from '@/Factories/ControlFactories/EmptyElementFactory';
import ComponentManager from '@/Management/ComponentManager';
import * as Interfaces from '#/CoreFrameInterfaces';
import NavigationHelper from '@/Management/NavigationHelper';
import * as CoreFrameDTOs from "coreframetypings/dto";
import Messenger from '@/Utility/Messenger';
import { IEmbeddedListViewFactoryParameters, IGridControlFactory } from '#/DefaultViewExtensionInterfaces';

export default class JournalEntriesFactory extends ControlFactory implements IGridControlFactory {
    private EmbeddedListViewFactory = ComponentManager.getFactory<typeof EmbeddedListViewFactoryT>('EmbeddedListView');
    private EmptyElementFactory = ComponentManager.getFactory<typeof EmptyElementFactoryT>('EmptyElement');
    private innerFactory: ControlFactory;
    private visibleColumns: string[] = ['ChangeDate', 'Author.ObjectIdentValue', 'JournalEntryType.MLSValue', 'Changes'];
    private messageIsRegistered: boolean;
    private static AppliedMessageId = 'DetailViewContextAppliedMessage';

    constructor(params: Interfaces.IControlFactoryConstructorParameter) {
        super(params);

        const showJournalEntries = !this.context.genericObject.isHistorized && this.context.genericObject.getValue('ShowJournalEntries');
        if (showJournalEntries) {
            const filter = `this.SourceObjectOid = ${this.context.genericObject.pdoId} AND this.HasReadRightOnSource = true`;
            const journalPdTypeName = 'RAD.RADFoundation.ProblemDomain.Journal.JournalEntry';

            Messenger.registerForMessageId(JournalEntriesFactory.AppliedMessageId,
                (_) => {
                    const vm = this.innerFactory.viewModel as any;
                    if (vm)
                        vm.dataGrid.refresh();
                },
                this);

            this.messageIsRegistered = true;

            const elvParams: IEmbeddedListViewFactoryParameters = {
                ...params,
                typeName: journalPdTypeName,
                filter: filter,
                showFilter: true,
                showEdit: true,
                lazyLoading: true,
                onEdit: (pdoId: string, openInNewWindow: boolean) => {
                    NavigationHelper.openListViewByTypeFromDetailView(this.context, journalPdTypeName,
                        {
                            selectedPDO: pdoId,
                            filter: filter,
                            disablePrincipalFilter: true,
                            showPrincipalFilter: false
                        },
                        openInNewWindow);
                },
                onBeforeListViewLoaded: (listViewDto: CoreFrameDTOs.IListViewDTO) => {
                    listViewDto.columns.forEach(column => {
                        column.isVisible = this.visibleColumns.indexOf(column.name) > -1;
                    });
                },
                getStorageColumnDefinitionKey: () => {
                    return this.context.getPdTypeName() + '_JournalEntries';
                },
                inheritPersistenceContext: true,
                disablePrincipalFilter: true
            };
            this.innerFactory = new this.EmbeddedListViewFactory(elvParams);
        } else {
            this.isVisible(false);
            this.innerFactory =
                new this.EmptyElementFactory({ detailViewItem: params.detailViewItem});
        }
    }
    
    public getContainerPostfix(): KnockoutObservable<string> {
        if (this.innerFactory instanceof this.EmbeddedListViewFactory) {
            return this.innerFactory.getContainerPostfixWithoutInit()
        }
        return this.observableOrDefault('');
    }

    protected disposeInternal(): void {
        if (this.messageIsRegistered)
            Messenger.unregisterForMessageId(JournalEntriesFactory.AppliedMessageId, null, this);

        super.disposeInternal();
    }

    public getControl(): JQuery {
        return this.innerFactory.getControl();
    }
}

ComponentManager.setFactory('JournalEntries', JournalEntriesFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');